import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spin, Button } from 'antd';
import filter from 'lodash/filter';
import { useSelector } from 'react-redux';
import size from 'lodash/size';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import each from 'lodash/each';
import { useTranslation } from 'react-i18next';
import useFetch from 'utils/fetch/useFetch';
import { USERS, BOXES, DEVICES } from 'api';
import Header from './components/HeaderLinks';
import List from './components/List';
import Filter from '../../components/Filter/index';
import AddTenantModal from './components/AddTenant';

function Customers() {
  const [expiredUsers, setExpired] = useState(null);
  const [users, setUsers] = useState([]);
  const [limit, setLimit] = useState(10);
  const [visible, setVisible] = useState(false);
  const options = useSelector((state) =>
    get(state, `fetch.users.filter`, null),
  );
  const { t } = useTranslation();
  const { data, getData, loading, updateData, total, loadMore } = useFetch(
    USERS,
    {
      uniqId: 'users',
      autoFetch: true,
      initialOptions: {
        role: 'client',
      },
    },
  );

  const { data: allUsers, getAllUsers } = useFetch(USERS, {
    uniqId: 'allUsers',
    autoFetch: false,
  });

  const {
    data: boxes,
    getData: getBoxes,
    postData: postBox,
    loading: loadingBox,
    updateData: updateBox,
  } = useFetch(BOXES, {
    uniqId: 'boxes',
    autoFetch: false,
  });

  const {
    data: locks,
    getData: getDevices,
    updateData: updateDevice,
    loading: loadingDevice,
  } = useFetch(DEVICES, {
    uniqId: 'device',
    autoFetch: false,
  });

  const { data: expired, getData: getExpired } = useFetch(USERS, {
    uniqId: 'users_expired_7',
    autoFetch: false,
  });

  useEffect(() => {
    if (data && data.length !== 0) {
      getExpired({
        has_boxes_expire_in: 7,
      });
    } else {
      setUsers([]);
    }
  }, [data]);

  useEffect(() => {
    if (limit > 10) {
      getData({
        role: 'client',
        limit,
      });
    }
  }, [limit]);

  useEffect(() => {
    if (expired && expired.length !== 0 && data && data.length !== 0) {
      let empty = [];
      each(expired, (item) => {
        const itemEx = item;
        const itemData = filter(data, (item) => {
          return itemEx.id === item.id;
        });
        if (itemData.length !== 0) {
          empty.push({ ...itemData[0], soon: true });
        }
      });
      const newData = empty.concat(data);
      setUsers(
        uniqBy(newData, function (e) {
          return e.id;
        }),
      );
      setExpired(empty);
    } else if (data) {
      setUsers(data);
    }
  }, [expired]);

  return (
    <Spin spinning={loading}>
      {data && (
        <Header
          expired={expiredUsers ? expiredUsers.length : 0}
          getUsers={getData}
          users={users}
          total={total}
        />
      )}
      <div className="flex mb-5 mt-30">
        <Filter
          dataSource={data}
          updateData={getData}
          uniqId="users"
          placeholder={t('placeholderQuickCustomer')}
        />
        <Button
          type="primary"
          onClick={() => {
            setVisible(!visible);
          }}
        >
          Add tenant
        </Button>
      </div>
      {users && (
        <>
          <List
            locks={locks}
            getDevices={getDevices}
            getUsers={getData}
            loadingBox={loadingBox}
            boxes={boxes}
            getBoxes={getBoxes}
            updateBox={updateBox}
            users={users}
            updateData={updateData}
            updateDevice={updateDevice}
            postBox={postBox}
            loadingDevice={loadingDevice}
            allUsers={allUsers}
            getAllUsers={getAllUsers}
          />
          {total && total !== size(data) && (
            <div className="flex items-center p-20 w-full justify-center">
              <Button
                onClick={() => {
                  loadMore(20, options);
                }}
                type="primary"
              >
                {t('loadMore')}
              </Button>
            </div>
          )}
        </>
      )}
      <AddTenantModal
        postTransaction={null}
        loadingBox={loadingBox}
        boxes={boxes}
        getBoxes={getBoxes}
        storages={null}
        users={null}
        visible={visible}
        setVisible={setVisible}
      />
    </Spin>
  );
}

Customers.propTypes = {};

export default Customers;
